var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 15,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7348 17.6548V12.97C18.7348 10.46 17.3948 9.292 15.6084 9.292C14.1668 9.292 13.5208 10.0852 13.1608 10.6416V9.484H10.4448C10.4808 10.2508 10.4448 17.6548 10.4448 17.6548H13.1608V13.0916C13.1608 12.848 13.1784 12.604 13.2504 12.4296C13.4464 11.9416 13.8932 11.4364 14.6432 11.4364C15.6264 11.4364 16.0192 12.1856 16.0192 13.2836V17.6552H18.7348V17.6548ZM7.5836 8.3688C8.5304 8.3688 9.1204 7.7408 9.1204 6.9564C9.1028 6.1552 8.5304 5.5452 7.6016 5.5452C6.6728 5.5452 6.0652 6.1548 6.0652 6.9564C6.0652 7.7408 6.6548 8.3688 7.5664 8.3688H7.5836ZM12 24C5.3728 24 0 18.6272 0 12C0 5.3724 5.3728 0 12 0C18.6272 0 24 5.3724 24 12C24 18.6272 18.6272 24 12 24ZM8.9416 17.6548V9.484H6.226V17.6548H8.9416Z",
    fill: "#2867B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkin);
export default __webpack_public_path__ + "static/media/linkin.55f0c593884b075587c83a774e5dc266.svg";
export { ForwardRef as ReactComponent };